module.exports = "https://static.wmbcdn.com/uniweb/images/bfb29a20bd7a107f6438608cf55094c9.svg";